<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h410_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="所属省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      :disabled="eventType === 'view'"
                      @change="changeProvinceFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="年份"
                    prop="year"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.year"
                      filterable
                      clearable
                      placeholder="请选择年份"
                      style="width:100%"
                      :disabled="eventType === 'view'"
                    >
                      <el-option
                        v-for="item in yearOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="天数"
                    prop="day"
                  >
                    <el-input-number
                      v-model="dialogAddEditViewForm.day"
                      :min="0"
                      :max="9999"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { initMaterialsSchemeTraceSendDaySettingApi, saveOrUpdateMaterialsSchemeTraceSendDaySettingApi } from '@/api/materialsSchemeTraceSendDaySetting'

export default {
  components: { },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [ { required: true, message: '请选择所属省区', trigger: 'change' }],
        year: [ { required: true, message: '请选择所属年份', trigger: 'change' }],
        day: [ { required: true, message: '请输入天数', trigger: 'change' }],
        remark: [ { max: 500, message: '备注内容最多输入500个字符', trigger: 'blur' } ]
      },
      provinceOptions: [],
      yearOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.provinceOptions = []
        this.yearOptions = []
        this.dialogAddEditViewForm = {
          provinceName: '',
          provinceId: '',
          year: '',
          day: 0,
          status: 1,
          remark: ''
        }
        this.initProvinceSelectData()
        let currentDate = new Date()
        let currentYear = currentDate.getFullYear()
        for(let i = (currentYear - 1); i <= (currentYear + 2); i++){
          this.yearOptions.push({label: i, data: i})
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initMaterialsSchemeTraceSendDaySettingApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 初始省区下拉数据
    initProvinceSelectData(){
      loadAreaDataApi({ parentId: 1, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun(val){
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '方案痕迹化资料发送天数限制设置','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateMaterialsSchemeTraceSendDaySettingApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>

</style>
